export default __webpack_public_path__ + "static/media/pic2.b6e7730a.jpg";